var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"content-wrapper"},[_c('loading',{attrs:{"isActive":_vm.loading}}),_c('h1',{staticClass:"title"},[(_vm.icon)?_c('fa-icon',{attrs:{"icon":_vm.icon}}):_vm._e(),_vm._v(" "+_vm._s(_vm.descPlural)+" ")],1),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }